jQuery(document).ready(function($) {
  console.log('GHIAIA Scripts Loaded!');

  // mega menu
  $('.trigger-menu').on('click', function(e){
    e.preventDefault();

    if($('body').hasClass('megamenu-expanded')){
      $('body').removeClass('megamenu-expanded');
    } else {
      $('body').addClass('megamenu-expanded');
      $('#ghiaia-mega-menu').addClass('active');
    }
  });

  $('.close-mega-menu').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('megamenu-expanded');
    $('#ghiaia-mega-menu').removeClass('active');
  });

  // home slider
  $('#ghiaia-stories-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    speed:500,
    fade: true, 
    cssEase:"linear",
    pauseOnHover: false
  });

  // resize hero banner
  resize_home_banner();
  $(window).resize(function(){
    resize_home_banner();
  });
  
  function resize_home_banner(){
    var window_height = $(window).height();
    $('.ghiaia__home-banner').height(window_height + 'px');
  }

  // resize carousel wrapper
  var $window_width = $(window).width();

  if($window_width > 1440){
    var $padding = ($window_width - 1440) / 2;
    $('#ghiaia-tabbed-products').css('padding-left', $padding + 50 + 'px');
  }

  

  

  // wrap 2 banner items
  // $('#shopify-section-template--21486391001402__459af907-c1ee-4fd8-a116-52439c64008f, #shopify-section-template--21486391001402__cc09a9bc-692d-4d3e-a19a-08dc23f282a5').wrapAll('<div id="home__2-col-banner"></div>');
  $('#shopify-section-template--25049728090305__459af907-c1ee-4fd8-a116-52439c64008f, #shopify-section-template--25049728090305__cc09a9bc-692d-4d3e-a19a-08dc23f282a5').wrapAll('<div id="home__2-col-banner"></div>');

  
  

  // $('.product__info-wrapper variant-selects .product-form__input.product-variant-select__size select option').removeAttr('selected');
  // $('.product__info-wrapper variant-selects .product-form__input.product-variant-select__size select').prepend('<option value="" selected="selected">Select a size</option>');
  // $('.product__info-wrapper .product-form .product-form__submit').prop('disabled', true);
  // $('.product__info-wrapper variant-selects .product-form__input.product-variant-select__size select').on('change', function(){
  //     var $val = $('option:selected', this);
  //     if($val != ''){
  //       $('.product__info-wrapper .product-form .product-form__submit').prop('disabled', false);
  //     } else {
  //       $('.product__info-wrapper .product-form .product-form__submit').prop('disabled', true);
  //     }
  // });
});

/*****************************
* Collection: Ajax load more
******************************/
class LoadMore extends HTMLElement { 
  constructor(){
    super();
    this.addEventListener("click", this.loadMoreItems);
  }

  loadMoreItems() { 
   
    const loadMoreBtn = this.querySelector('[type="button"]');
    loadMoreBtn.setAttribute("disabled", true);

    let { currentPage, pageSize, nextUrl, totalItems } = this.dataset
    let nextPage = parseInt(this.dataset.currentPage) + 1
    
    fetch(nextUrl.replace(/page=[0-9]+/,'page='+ nextPage))
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        $('#product-grid').append($(html).find('#product-grid').html());
      }).catch((e) => {
        // handle error
        console.error(e);
      })
      .finally(() => {
        loadMoreBtn.removeAttribute("disabled");
        this.dataset.currentPage = parseInt(this.dataset.currentPage) + 1;
        
        let isLastPage = parseInt(totalItems) - (nextPage * parseInt(pageSize) ) < 0
        //this.querySelector('[load-items-count]').innerHTML = isLastPage ? parseInt(totalItems) : nextPage * parseInt(pageSize)
        isLastPage && loadMoreBtn.setAttribute("disabled", true);
      });
  }
}

customElements.define('load-more', LoadMore);